<template>
  <div v-if="metadata">
    <div class="search-form-title">詳細プロフィール</div>
    <div class="search-form">
      <table>
        <tr>
          <th>ニックネーム</th>
          <td>{{ userDetail.display_name }}</td>
        </tr>
        <tr>
          <th>性別</th>
          <td>{{ getGender(userDetail.sex) }}</td>
        </tr>
        <tr>
          <th>年齢</th>
          <td>{{ userDetail.age }}歳</td>
        </tr>
        <tr>
          <th>身長</th>
          <td>
            <select v-model="formData.height" name="min_height" class="s-form01" @change="$emit('setData',formData)">
              <option :value="null" disabled selected>選択してください</option>
              <option :value="item.value" v-for="(item, index) in metadata.user_profile_list.height" :key="index">{{item.name}}</option>
            </select>
          </td>
        </tr>
        <tr>
          <th>体型</th>
          <td>
            <select v-model="formData.style" name="style" class="s-form01" @change="$emit('setData',formData)">
              <option :value="null" disabled selected>選択してください</option>
              <option v-for="(item, index) in metadata.user_profile_list.style" :key="index" :value="item.value">{{ item.name }}</option>
            </select>
          </td>
        </tr>
        <tr>
          <th>居住地</th>
          <td>
            <select v-model="formData.living_area" name="living_area" class="s-form01" @change="$emit('setData',formData)">
              <option :value="null" disabled selected>選択してください</option>
              <option v-for="(item, index) in metadata.user_profile_list.living_area" :key="index" :value="item.value">{{ item.name }}</option>
            </select>
          </td>
        </tr>
        <tr>
          <th>出身地</th>
          <td>
            <select v-model="formData.birth_place" name="birth_place" class="s-form01" @change="$emit('setData',formData)">
              <option :value="null" disabled selected>選択してください</option>
              <option v-for="(item, index) in metadata.user_profile_list.birth_place" :key="index" :value="item.value">{{ item.name }}</option>
            </select>
          </td>
        </tr>
        <tr>
          <th>同居人</th>
          <td>
            <select v-model="formData.roommate" name="roommate" class="s-form01" @change="$emit('setData',formData)">
              <option :value="null" disabled selected>選択してください</option>
              <option v-for="(item, index) in metadata.user_profile_list.roommate" :key="index" :value="item.value">{{ item.name }}</option>
            </select>
          </td>
        </tr>
        <tr>
          <th>子供の有無</th>
          <td>
            <select v-model="formData.child" name="child" class="s-form01" @change="$emit('setData',formData)">
              <option :value="null" disabled selected>選択してください</option>
              <option v-for="(item, index) in metadata.user_profile_list.child" :key="index" :value="item.value">{{ item.name }}</option>
            </select>
          </td>
        </tr>
        <tr>
          <th>学歴</th>
          <td>
            <select v-model="formData.education" name="education" class="s-form01" @change="$emit('setData',formData)">
              <option :value="null" disabled selected>選択してください</option>
              <option v-for="(item, index) in metadata.user_profile_list.education" :key="index" :value="item.value">{{ item.name }}</option>
            </select>
          </td>
        </tr>
        <tr>
          <th>職業</th>
          <td>
            <select v-model="formData.job" class="s-form01" @change="$emit('setData',formData)">
              <option :value="null" disabled selected>選択してください</option>
              <option v-for="(item, index) in metadata.user_profile_list.job" :key="index" :value="item.value">{{ item.name }}</option>
            </select>
          </td>
        </tr>
        <tr>
          <th>年収</th>
          <td>
            <select v-model="formData.income" name="income" class="s-form01" @change="$emit('setData',formData)">
              <option :value="null" disabled selected>選択してください</option>
              <option v-for="(item, index) in metadata.user_profile_list.income" :key="index" :value="item.value">{{ item.name }}</option>
            </select>
          </td>
        </tr>
        <tr>
          <th>休日</th>
          <td>
            <select v-model="formData.holidays" name="holidays" class="s-form01" @change="$emit('setData',formData)">
              <option :value="null" disabled selected>選択してください</option>
              <option v-for="(item, index) in metadata.user_profile_list.holidays" :key="index" :value="item.value">{{ item.name }}</option>
            </select>
          </td>
        </tr>
        <tr>
          <th>お酒</th>
          <td>
            <select v-model="formData.drinking" name="drinking" class="s-form01" @change="$emit('setData',formData)">
              <option :value="null" disabled selected>選択してください</option>
              <option v-for="(item, index) in metadata.user_profile_list.drinking" :key="index" :value="item.value">{{ item.name }}</option>
            </select>
          </td>
        </tr>
        <tr>
          <th>タバコ</th>
          <td>
            <select v-model="formData.smoking" name="smoking" class="s-form01" @change="$emit('setData',formData)">
              <option :value="null" disabled selected>選択してください</option>
              <option v-for="(item, index) in metadata.user_profile_list.smoking" :key="index" :value="item.value">{{ item.name }}</option>
            </select>
          </td>
        </tr>
        <tr>
          <th>好きな事・趣味</th>
          <td>
            <a @click="$emit('closeMain', 'hobby')">{{ userDetail.hobby ? userDetail.hobby : '記入する' }}</a>
          </td>
        </tr>
        <tr>
          <th>よく行く場所</th>
          <td>
            <a @click="$emit('closeMain', 'favorite')">{{ userDetail.favorite_place ? userDetail.favorite_place : '記入する' }}</a>
          </td>
        </tr>
        <tr>
          <th>初デートで行きたい場所</th>
          <td>
            <a @click="$emit('closeMain', 'firstPlace')">{{ userDetail.first_place ? userDetail.first_place : '記入する' }}</a>
          </td>
        </tr>
        <tr>
          <th>出会うまでの希望</th>
          <td>
            <select v-model="formData.meeting_condition" name="meeting_condition" class="s-form01" @change="$emit('setData',formData)">
              <option :value="null" disabled selected>選択してください</option>
              <option v-for="(item, index) in metadata.user_profile_list.meeting_condition" :key="index" :value="item.value">{{ item.name }}</option>
            </select>
          </td>
        </tr>
        <tr>
          <th>会ったときの希望</th>
          <td>
            <select v-model="formData.purpose"  class="s-form01" @change="$emit('setData',formData)">
              <option :value="null" disabled selected>選択してください</option>
              <option v-for="(item, index) in metadata.user_profile_list.purpose" :key="index" :value="item.value">{{ item.name }}</option>
            </select>
          </td>
        </tr>
        <tr>
          <th></th>
          <td></td>
        </tr>
        <tr>
          <th></th>
          <td></td>
        </tr>
        <tr>
          <th></th>
          <td></td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import mixin from '@/mixin'
import CONSTANTS from '@/constants'
export default {
  mixins: [mixin],
  props: {
    userDetail: Object,
  },
  data: () => ({
    DEFAULT_VALUE: CONSTANTS.DEFAULT_VALUE,
    MALE: CONSTANTS.MALE,
    formData: {
      style:  null,
      living_area:  null,
      birth_place:  null,
      roommate:  null,
      child:  null,
      education:  null,
      job:  null,
      income:  null,
      holidays:  null,
      drinking:  null,
      smoking:  null,
      hobby: null,
      favorite_place: null,
      first_place: null,
      meeting_condition:  null,
      purpose:  null,
      height:  null
    },
  }),
  computed: {
      ...mapGetters(["metadata"])
  },
  created() {
    if (!this.metadata) {
      this.getMetadata() 
    }
    if (this.userDetail) {
      this.formData = {
        style:  this.userDetail.style,
        living_area:  this.userDetail.living_area,
        birth_place:  this.userDetail.birth_place,
        roommate:  this.userDetail.roommate,
        child:  this.userDetail.child,
        education:  this.userDetail.education,
        job:  this.userDetail.job,
        income:  this.userDetail.income,
        holidays:  this.userDetail.holidays,
        drinking:  this.userDetail.drinking,
        smoking:  this.userDetail.smoking,
        hobby: this.userDetail.hobby,
        favorite_place: this.userDetail.favorite_place,
        first_place: this.userDetail.first_place,
        meeting_condition:  this.userDetail.meeting_condition,
        purpose:  this.userDetail.purpose,
        height:  this.userDetail.height
      }
    }
  },
  methods: {
    ...mapActions({
      getMetadata: 'metadata/getMetadata',
    }),
  },
};
</script>

<style scoped>
  table {
      table-layout:fixed;
  }
  @media only screen and (max-width: 457px) {
      .search-form th {
          width: 38%;
          padding: 14px 0;
          vertical-align: middle;
          line-height: 16px;
          font-size: 11px;
      }
      .search-form td {
          width: 62%;
      }
  }
</style>